import { UserAuditLogEntry } from 'apis/auditLogs';

import { ConversationLink } from './conversationLink/conversationLink';
import { UserActivityCard } from './userActivityCard';
import { channelRefIcon, statusColors } from './userActivityTypes.utils';

type ConversationStartedProps = {
  entry: UserAuditLogEntry<'CONVERSATION_CREATED'>;
};

export const ConversationStarted = ({
  entry,
}: ConversationStartedProps): JSX.Element => (
  <UserActivityCard
    entry={entry}
    icon={channelRefIcon(entry.channel_ref)}
    color={statusColors.info}
    title="Conversation"
    titleSuffix={
      <ConversationLink
        conversationId={entry.conversation_id}
        onClick={(event) => event.stopPropagation()}
      >
        #{entry.conversation_id}
      </ConversationLink>
    }
    summary={entry.subject}
  />
);
